export const X_PLATFORM_ID_MAP = {
  dev: {
    HM: 3,
    DCS: 4,
    LM: 5,
    MNP: 6,
    PP: 7,
    PM: 8,
    HN: 9,
    RS: 10,
    YT: 11,
    FP: 12,
    AQUA: 13,
  },
  alpha: {
    HM: 3,
    DCS: 4,
    LM: 5,
    MNP: 6,
    PP: 7,
    PM: 8,
    HN: 9,
    RS: 10,
    YT: 11,
    FP: 12,
    AQUA: 13,
  },
  beta: {
    HM: 1,
    DCS: 4,
    LM: 5,
    MNP: 6,
    PP: 7,
    PM: 8,
    HN: 9,
    RS: 10,
    YT: 11,
    FP: 12,
    AQUA: 13,
  },
  gamma: {
    HM: 1,
    DCS: 4,
    LM: 5,
    MNP: 6,
    PP: 7,
    PM: 8,
    HN: 9,
    RS: 10,
    YT: 11,
    FP: 12,
    AQUA: 13,
  },
  production: {
    HM: 1,
    DCS: 4,
    LM: 5,
    MNP: 6,
    PP: 7,
    PM: 8,
    HN: 9,
    RS: 10,
    YT: 11,
    FP: 12,
    AQUA: 13,
  },
}
